import styled from "@rentiohq/web-theme";

export const FixedCell = styled.div`
  white-space: nowrap;
  text-overflow: ellipsis;
`;
